<template>
    <div class="address-list">
        <navigation-bar Close/>
        <el-button type="text" @click="gotoCamera" class="qrcode-btn">
            <img src="@/assets/images/qrcode.svg" alt="掃碼">掃 碼
        </el-button>
        <div class="main">
            <!--todo 沒有地址時預設畫面-->
            <div class="preset-con" v-if="dataList.length === 0">
                <img src="../../assets/images/add_address.svg">
                <h4>OH!還沒新增收件地址呢</h4>
                <el-button type="warning" round @click="$router.push({name: 'OrderAddress', params: {'id': 0}})">新增地址
                </el-button>
            </div>

            <!--todo 地址列表-->
            <div class="container mt-3" v-else>
                <div class="text-right">
                    <el-button type="warning" round @click="$router.push({name: 'OrderAddress', params: {'id': 0}})">
                        新增地址
                    </el-button>
                </div>

                <div class="list_content" v-for="(item, index) in dataList" :key="index" @click="useAddr(item)">
                    <div class="title">
                        <!--todo 預設的樣式-->
                        <template v-if="item.isDefault">
                            <img src="@/assets/images/address_preset.svg">
                            {{item.name}}
                        </template>
                        <!--todo 一般的樣式-->
                        <template v-else>
                            <img src="@/assets/images/star_line.svg">
                            {{item.name}}
                        </template>
                    </div>
                    <div class="delete" @click.stop="openDeleteUserAddressDialog(item, index)">
                        <img src="@/assets/images/delete_blue_line.svg" alt="刪除">
                    </div>
                    <div class="add">
                        <p>{{item.completeAddress}}</p>
                        <p class="small gray">外送指示：{{item.content}}</p>
                    </div>
                    <div class="btn-edit" @click.stop="$router.push({name: 'OrderAddress', params: {'id': item.id}})">
                        <img src="@/assets/images/edit2.svg" alt="編輯">
                    </div>
                </div>

            </div>

            <comm-dialog :value="isShowDialog"
                         :outerContent="'確定刪除地址？'"

                         @result="onDialogResult">

            </comm-dialog>
        </div>
    </div>
</template>

<script>
    import CommDialog from '@/components/CommDialog.vue'
    import * as mutationTypes from "@/store/mutationTypes";
    import * as constDefine from '@/store/constDefine';

    export default {
        name: "OrderAddressList",
        components: {
            CommDialog,
        },
        data() {
            return {
                isShowDialog: false,
                selectItem: {},
                selectIndex: 0,
                dataList: [],
            }
        },
        created() {
            //讀取掃描結果
            let scanResult = sessionStorage.getItem('cameraResult');
            if (scanResult !== null && scanResult !== '') {
                //讀取完要清除，要再取得結果就要重新掃描
                sessionStorage.setItem('cameraResult', '');
                this.onScanResult(scanResult);
            }

            this.setupData()
        },
        methods: {
            setupData() {
                this.isLoading = true
                this.$http.fetchWithAuth`GetUserAddressList${{}}
                ${json => {
                    if (json.status) {
                        this.dataList = json.data.dataList
                    }
                    this.isLoading = false
                }}`;
            },
            openDeleteUserAddressDialog(item, index) {
                this.selectItem = item
                this.selectIndex = index
                this.isShowDialog = true
            },
            onDialogResult(isSure) {
                if (isSure) {
                    this.$http.fetchWithAuth`DeleteUserAddress${{
                        'id': this.selectItem.id
                    }}
                    ${json => {
                        if (json.status) {
                            this.dataList.splice(this.selectIndex, 1)
                        }
                        this.$public.showNotify(json.message, json.status);
                        this.isShowDialog = false;
                    }}`;
                } else {
                    this.isShowDialog = false;
                }
            },
            useAddr(item) {
                this.$store.commit("updateCartUserAddressId", item.id)
                this.$store.commit("updateCartUserAddressParams", {
                    isDelivery: true,
                })
                this.$router.go(-1);
            },
            /** 開啓相機 */
            gotoCamera() {
                this.$router.push({name: `ScanCode`});
            },
            onScanResult: function (value) {
                if (value !== "") {
                    let scanParamData = {}
                    let storeId = 0
                    let tableId = 0
                    let data = this.$public.dataTokenObject(value)
                    if(data.status) {
                        scanParamData = data.dataObject
                    } else {
                        try {
                            scanParamData = JSON.parse(value);
                        } catch (e) {
                            scanParamData = {}
                        }
                    }

                    switch (scanParamData.usedType) {
                        case constDefine.QRCodeUsedType.GetInfo:
                            storeId = scanParamData.id
                            break;
                        case constDefine.QRCodeUsedType.TableOrder:
                            storeId = scanParamData.storeId
                            tableId = scanParamData.tableId
                            break;
                    }

                    if(storeId > 0) {
                        this.$store.commit("updateCartUserAddressId", -1)
                        this.$store.commit("updateCartUserAddressParams", {
                            isDelivery: true,
                            storeId: storeId,
                            tableId: tableId,
                        })
                        this.$router.go(-1);
                    } else {
                        this.$public.showNotify("請確認QRCode用途", false);
                    }
                }
            },
        }
    }
</script>

<style lang="less" scoped src="../../less/order.less"/>